// TODO odstranit podla configu

export const storyParagraphs: StoryParagraphs = {
	// Reprezentuje prvotny pribeh
	1: {
		1: "intro.slide_1",
		2: "intro.slide_2",
		3: "intro.slide_3",
		4: "intro.slide_4",
		5: "intro.slide_5",
		6: "intro.slide_6",
		7: "intro.slide_7",
		8: "intro.slide_8",
		9: "intro.slide_9",
		10: "intro.slide_10",
		11: "intro.slide_11",
		12: "intro.slide_12",
	},
	2: {
		1: "outro.chapter_1.slide_1",
		2: "outro.chapter_1.slide_2",
		3: "outro.chapter_1.slide_3",
	},
	3: {
		1: "outro.chapter_2.slide_1",
		2: "outro.chapter_2.slide_2",
		3: "outro.chapter_2.slide_3",
		4: "outro.chapter_2.slide_4",
		5: "outro.chapter_2.slide_5",
		6: "outro.chapter_2.slide_6",
		7: "outro.chapter_2.slide_7",
		8: "outro.chapter_2.slide_8",
		9: "outro.chapter_2.slide_9",
		10: "outro.chapter_2.slide_10",
		11: "outro.chapter_2.slide_11",
		12: "outro.chapter_2.slide_12",
	},
	4: {
		1: "outro.chapter_3.slide_1",
		2: "outro.chapter_3.slide_2",
		3: "outro.chapter_3.slide_3",
		4: "outro.chapter_3.slide_4",
		5: "outro.chapter_3.slide_5",
		6: "outro.chapter_3.slide_6",
		7: "outro.chapter_3.slide_7",
		8: "outro.chapter_3.slide_8",
		9: "outro.chapter_3.slide_9",
		10: "outro.chapter_3.slide_10",
		11: "outro.chapter_3.slide_11",
		12: "outro.chapter_3.slide_12",
	},
};

export type StoryParagraphs = {
	[storyId: number]: {
		[paragraphId: number]: string;
	};
};
